export const GET_WALLBOARD_QUEUES = 'GET_WALLBOARD_QUEUES';